/* ==================================================== claude-price-preview.js
   NEXT-HAT personalized pricing (Adam, 2026-08-27, in two steps):
   1. "when there is nothing in the cart ... change the price of the products
      to the discount code ... original pricing with a line through it ...
      under the price say Pricing based on and then the discount code name"
   2. "i added one to the cart and the next level is 2 for 60 ... the new
      price should show whats coming next if a discount code isn't applied or
      even if the next hats cart level discount will supercede the discount
      code and what price and discount code will be automatically used next"

   So: every eligible product's price becomes WHAT ADDING THAT HAT WOULD
   ACTUALLY COST, under whichever discount wins at the next cart state —
   the shopper's code or the next ladder tier — attributed by name:

     empty cart + WELCOME20   ->  ~~$34.99~~ $28.00   "Pricing based on WELCOME20"
     1 hat, no code           ->  ~~$34.99~~ $25.01   "Pricing based on 2 Hats For $60"
     1 hat + WELCOME20        ->  ~~$34.99~~ $28.00   (code still beats the ladder)
     3 hats + WELCOME20       ->  ~~$34.99~~ $16.00   "Pricing based on 4 Hats for $100"
     4 hats, no code          ->  ~~$34.99~~ $25.00   "Pricing based on 5 Hats For $125"

   SEO-GATED BY CONSTRUCTION: a visitor with an empty cart and no discount
   code — which is every crawler, always — sees normal prices and this file
   does nothing (not even the eligibility fetch). Product schema and any
   Shopping feed stay truthful. Do NOT add an "everyone" mode.

   THE LADDER MATH IS MEASURED, NOT ASSUMED (live carts, 2026-08-27): the
   automatic discounts are fixed AMOUNTS OFF tuned to $34.99 hats — $9.98
   off at 2, $19.97 at 3, $39.96 at 4, $49.95 at 5 ("5 Hats For $125!" is a
   real configured discount) — which lands 2/$60, 3/$85, 4/$100, 5/$125 and
   $25/hat beyond. Tier totals are derived from the SAME milestone labels
   the reward bar renders (data-milestones on #claude-cart-root), so Adam
   retuning the ladder in the section settings retunes this too. Past the
   last labeled tier we extend at EXTRA_CENTS per hat (verified at 5).

   Shopify never tells the storefront what a CODE does, so code math lives
   in CODE_RULES: one line per active code. An unknown code shows ladder
   pricing only — safe, never wrong. Codes TRUNCATE to the cent (measured:
   20% of $34.99 is $6.99 off, not $7.00). Eligibility is the reward bar's
   own list (?view=handles, shared sessionStorage cache), so beanies,
   stickers, ropes, paddles, gift cards and SALE stay at full price. */
(function () {
  'use strict';

  /* ---- the rules table: add a line here when a new code goes live ---- */
  var CODE_RULES = {
    /* every ACTIVE sitewide percentage code, read from Shopify on launch
       night 2026-08-27 — a code missing here shows normal pricing (safe),
       it never guesses. New code in admin = one line here. */
    /* SALE OVER (Monday 2026-08-31, Adam: "we are going back to the
       previous promotion") — every code back to its percentage, the
       three paused codes reactivated, all matching the 08-31 admin
       revert (ledger: 09-DATA/pricing/code-weekend-2026-08-28.json). */
    'WELCOME20': { pct: 20 },
    'WELCOME15': { pct: 15 },
    'WELCOMEBACK25': { pct: 25 },
    'LIVEWITHPASSION15': { pct: 15 },
    'TENOFFNOW': { pct: 10 },
    'FIRSTORDER': { pct: 10 },
    /* the Klaviyo FLOW codes, swept from live flows 2026-08-28 */
    'CART20': { pct: 20 },
    'CHECKOUT20': { pct: 20 },
    'EXCLUSIVE20': { pct: 20 },
    'THANKS20': { pct: 20 },
    'COMEBACK20': { pct: 20 },
    'CART25': { pct: 25 },
    'CHECKOUT25': { pct: 25 },
    'EXCLUSIVE25': { pct: 25 },
    /* BACKAGAIN is 30% off ALL ITEMS (not hats-only) */
    'BACKAGAIN': { pct: 30 },
    /* one-off, single use — restored to plain 50% on 08-31 (unused) */
    'ANDREWP1': { pct: 50 }
  };

  var BASE_CENTS = 3499;    /* back to the standing $34.99 base (sale over, 2026-08-31) */
  var EXTRA_CENTS = 2500;   /* per-hat total past the last labeled tier ("$25ea", 10/$250 ladder) */

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function codeOff(cents, rule) {
    /* two rule shapes: {pct} takes a percentage per line; {off} takes a
       fixed amount per line (the WEEKEND shape — Adam, 2026-08-28: codes
       "work off the 34.99", so Shopify holds them as fixed per-item
       amounts until Monday). Never below zero. */
    if (rule.off) return Math.min(rule.off, cents);
    return Math.floor(cents * (rule.pct || 0) / 100);
  }

  function activeCode() {
    var c = '';
    try { c = sessionStorage.getItem('ccart-promo') || ''; } catch (e) {}
    if (!c) {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if (m) c = decodeURIComponent(m[1]);
    }
    return (c || '').trim().toUpperCase();
  }

  /* ---- the ladder, from the reward bar's own milestone data ---- */
  var cartRoot = document.getElementById('claude-cart-root');
  var eligibleCollection = (cartRoot && cartRoot.dataset.eligible) || 'discount-collection-hats';
  var tiers = [];   /* [{count, cents, label}] ascending */
  ((cartRoot && cartRoot.dataset.milestones) || '').split(';;').forEach(function (m) {
    var p = m.split('|');
    var count = parseInt(p[0], 10) || 0;
    var dollars = (p[1] || '').match(/\$\s*(\d+(?:\.\d{1,2})?)/);
    if (count > 0 && dollars) {
      tiers.push({ count: count, cents: Math.round(parseFloat(dollars[1]) * 100),
                   label: (p[1] || '').replace(/\s*!+\s*$/, '') });
    }
  });
  tiers.sort(function (a, b) { return a.count - b.count; });

  /* set-total the ladder charges for k hats, and the tier's display name */
  function ladderTier(k) {
    var last = null;
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].count === k) return tiers[i];
      if (tiers[i].count < k) last = tiers[i];
    }
    if (last && k > last.count) {
      var cents = last.cents + EXTRA_CENTS * (k - last.count);
      return { count: k, cents: cents, label: k + ' Hats For $' + (cents / 100) };
    }
    return null;
  }

  /* ---- eligibility: the reward bar's own list, same cache ---- */
  var eligibleSet = null;
  function loadEligibleSet() {
    if (eligibleSet) return Promise.resolve(eligibleSet);
    try {
      var cached = JSON.parse(sessionStorage.getItem('ccart-set') || 'null');
      if (cached && cached.c === eligibleCollection && cached.h) {
        eligibleSet = {};
        cached.h.forEach(function (h) { eligibleSet[h] = 1; });
        return Promise.resolve(eligibleSet);
      }
    } catch (e) {}
    function page(n, acc) {
      return fetch('/collections/' + eligibleCollection + '?view=handles&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          acc = acc.concat(d.handles || []);
          return n < d.pages ? page(n + 1, acc) : acc;
        });
    }
    return page(1, []).then(function (handles) {
      eligibleSet = {};
      handles.forEach(function (h) { eligibleSet[h] = 1; });
      try {
        sessionStorage.setItem('ccart-set', JSON.stringify({ c: eligibleCollection, h: handles }));
      } catch (e) {}
      return eligibleSet;
    }).catch(function () { return null; });   /* no list -> no preview */
  }

  /* ---- the quote: what one more hat at `cents` really costs ----
     ctx is rebuilt from the live cart on every change:
       k        eligible hats in the cart
       curAfter eligible total as Shopify has ALREADY discounted it
       lines    each eligible line's original total (for per-line code floor)
       curOrig  sum of lines
     Candidates for the next state, cheapest wins:
       keep    curAfter + cents                    (no new discount)
       code    per-line truncated pct off everything eligible + the new hat
       ladder  original eligible total + hat - the (k+1)-tier amount off,
               expressed via the tier's set total at BASE_CENTS hats */
  function quote(ctx, cents) {
    var best = { total: ctx.curAfter + cents, name: null };
    if (ctx.rule) {
      var t = cents - codeOff(cents, ctx.rule);
      ctx.lines.forEach(function (l) { t += l - codeOff(l, ctx.rule); });
      if (t < best.total) best = { total: t, name: ctx.code };
    }
    var tier = ladderTier(ctx.k + 1);
    if (tier) {
      var off = (ctx.k + 1) * BASE_CENTS - tier.cents;   /* the measured amount-off */
      var lt = ctx.curOrig + cents - off;
      if (lt < best.total) best = { total: lt, name: tier.label };
    }
    if (!best.name) return null;
    var marginal = best.total - ctx.curAfter;
    if (marginal >= cents || marginal < 0) return null;
    return { cents: marginal, name: best.name };
  }

  function previewHTML(orig, q, compare) {
    /* the struck figure is ALWAYS the compare-at when one exists (Adam,
       launch night: "always the 34.99 is swiped through for the next
       discount") — striking the already-discounted $29.99 undersold the
       deal */
    var was = compare && compare > orig ? compare : orig;
    return '<s class="c3d-pp-was">' + money(was) + '</s> ' +
      '<span class="c3d-pp-now">' + money(q.cents) + '</span>' +
      '<span class="c3d-pp-note">Pricing based on<span class="c3d-pp-name">' + q.name + '</span></span>';
  }

  /* ---- product cards (collection pgrid + Featured Favorites) ---- */
  function renderCards(ctx, set) {
    var nodes = document.querySelectorAll('.c3d-pcard__price[data-cents]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var q = null;
      var cents = parseInt(el.dataset.cents, 10);
      if (ctx && set && set[el.dataset.handle] && cents) q = quote(ctx, cents);
      /* the ppkey guard matters: sync() rides a body-wide MutationObserver,
         so an unconditional innerHTML write would re-trigger it forever */
      if (q) {
        var key = q.cents + '|' + q.name;
        if (el.dataset.ppkey === key) continue;
        if (el.dataset.pporig === undefined) el.dataset.pporig = el.innerHTML;
        el.innerHTML = previewHTML(cents, q, parseInt(el.dataset.compare || el.dataset.ppcompare || 0, 10));
        el.dataset.ppkey = key;
        el.classList.add('is-pp');
      } else if (el.classList.contains('is-pp')) {
        el.innerHTML = el.dataset.pporig || '';
        delete el.dataset.ppkey;
        el.classList.remove('is-pp');
      }
    }
  }

  /* ---- the GLASS product page (the quick-view overlay) ----
     Opened from the cart's Suggested Add-Ons (and glass tiles). Its price
     is plain "$34.99" text, and its buy column stamps the handle on the
     stars div — the body observer resyncs when the overlay opens or a
     swatch swaps the page, so this needs no hook into claude-3d.js. */
  function renderGlassPdp(ctx, set) {
    var nodes = document.querySelectorAll('.c3d-ovl__pdp-price');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var col = (el.closest && el.closest('.c3d-ovl__pdp-col--buy')) || el.parentElement;
      var star = col && col.querySelector('[data-product-handle]');
      var handle = star && star.getAttribute('data-product-handle');
      var q = null;
      var cents = parseInt(el.dataset.ppcents || 0, 10);
      if (!cents) {
        var m = (el.textContent || '').match(/\$(\d+(?:\.\d{1,2})?)/);
        if (m) { cents = Math.round(parseFloat(m[1]) * 100); el.dataset.ppcents = cents; }
      }
      if (ctx && set && handle && set[handle] && cents) q = quote(ctx, cents);
      if (q) {
        var key = q.cents + '|' + q.name;
        if (el.dataset.ppkey === key) continue;
        if (el.dataset.pporig === undefined) el.dataset.pporig = el.innerHTML;
        el.innerHTML = previewHTML(cents, q, parseInt(el.dataset.compare || el.dataset.ppcompare || 0, 10));
        el.dataset.ppkey = key;
        el.classList.add('is-pp');
      } else if (el.classList.contains('is-pp')) {
        el.innerHTML = el.dataset.pporig || '';
        delete el.dataset.ppkey;
        el.classList.remove('is-pp');
      }
    }
  }

  /* ---- the product page ----
     The theme's price block rewrites itself on variant change (and renders
     supercents, so its TEXT can't be parsed). We leave it alone: prices come
     from /products/<handle>.js in cents, the current variant from the add
     form's [name=id], and our element sits BESIDE the theme's .price (which
     CSS hides while the preview is on) so the theme's own rewrites never
     touch ours. A MutationObserver on the theme block is the variant-change
     signal. */
  var pdp = null;           /* { box, priceEl, product, el, observer } */
  var pdpProduct;           /* fetched once per page */

  function pdpHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function pdpVariantCents(product) {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? parseInt(input.value, 10) : 0;
    var vs = product.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id === id) return vs[i].price;
    }
    return product.price;
  }

  function pdpVariantCompare(product) {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? parseInt(input.value, 10) : 0;
    var vs = product.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].id === id) return vs[i].compare_at_price || 0;
    }
    return product.compare_at_price || 0;
  }

  function renderPdp(ctx, set) {
    var handle = pdpHandle();
    if (!handle) return;
    var box = document.querySelector('.product-info__price');
    var priceEl = box && box.querySelector('.price');
    if (!priceEl) return;
    var eligible = ctx && set && set[handle];
    if (!eligible) { teardownPdp(); return; }
    if (pdpProduct === undefined) {
      pdpProduct = null;   /* fetch once; re-render lands via sync() */
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { pdpProduct = p; sync(); })
        .catch(function () {});
      return;
    }
    if (!pdpProduct) return;
    var q = quote(ctx, pdpVariantCents(pdpProduct));
    if (!q) { teardownPdp(); return; }
    if (!pdp) {
      var our = document.createElement('div');
      our.className = 'c3d-pp-pdp';
      box.insertBefore(our, priceEl);
      pdp = { box: box, priceEl: priceEl, el: our };
      pdp.observer = new MutationObserver(function () { sync(); });
      pdp.observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
      box.classList.add('c3d-pp-active');
    }
    var cents = pdpVariantCents(pdpProduct);
    var key = cents + '|' + q.cents + '|' + q.name;
    if (pdp.key !== key) {
      pdp.el.innerHTML = previewHTML(cents, q, pdpVariantCompare(pdpProduct));
      pdp.key = key;
    }
  }

  function teardownPdp() {
    if (!pdp) return;
    if (pdp.observer) pdp.observer.disconnect();
    pdp.box.classList.remove('c3d-pp-active');
    if (pdp.el.parentNode) pdp.el.parentNode.removeChild(pdp.el);
    pdp = null;
  }

  /* ---- cart state drives everything ---- */
  var lastCart = null;

  function buildCtx(set) {
    var code = activeCode();
    var rule = CODE_RULES[code] || null;
    var k = 0, curAfter = 0, curOrig = 0, lines = [];
    ((lastCart && lastCart.items) || []).forEach(function (it) {
      if (!set[it.handle]) return;
      k += it.quantity;
      curAfter += it.final_line_price;
      curOrig += it.original_line_price;
      lines.push(it.original_line_price);
    });
    /* nothing to say: no code AND no ladder tier reachable — every crawler
       lands here (empty cart, no cookie) and the page stays untouched */
    if (!rule && !ladderTier(k + 1)) return null;
    return { code: code, rule: rule, k: k, curAfter: curAfter, curOrig: curOrig, lines: lines };
  }

  function sync() {
    if (!lastCart) return;
    /* skip the eligibility fetch entirely for the codeless empty-cart
       visitor — i.e. for Googlebot */
    if (!CODE_RULES[activeCode()] && lastCart.item_count === 0) {
      pubCtx = null;
      pubReady = true;
      renderCards(null, null);
      renderGlassPdp(null, null);
      teardownPdp();
      return;
    }
    loadEligibleSet().then(function (set) {
      if (!set) return;
      var ctx = buildCtx(set);
      pubCtx = ctx;   /* the cart's add-on chips quote from this */
      pubReady = true;
      renderCards(ctx, set);
      renderGlassPdp(ctx, set);
      renderPdp(ctx, set);
    });
  }

  /* claude-cart.js asks THIS engine what the next hat really costs (Adam,
     2026-08-27: "the suggested add ons are talking to the rewards bar
     right now and they should actually function just like the pricing
     does predicting the next discount") — same quote(), same winner
     logic, one source of pricing truth. Returns {cents, name} or null
     when no discount would improve on full price. */
  var pubCtx = null;
  var pubReady = false;   /* undefined return = "ask me again in a moment" */
  window.__c3dQuoteNextHat = function (cents) {
    if (!pubReady) return undefined;
    if (!pubCtx || !cents) return null;
    return quote(pubCtx, cents);
  };

  document.addEventListener('ccart:state', function (e) {
    if (!e.detail) return;
    lastCart = e.detail;
    sync();
  });

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (c) { lastCart = c; sync(); })
    .catch(function () {});

  /* cards rendered after us (glass page transitions) get picked up too —
     renderCards is cheap and idempotent, so a debounced resync is enough */
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; sync(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
